module.exports = {
    productDetailsAdditionalAttributes: {
        productDetailsHealthStarRatingPath:
            'https://wowuatmediaaae.blob.core.windows.net/content/hsricons/',
    },
};



// WEBPACK FOOTER //
// ./src/common/settings/groups/product-details-additional-attributes.js